// extracted by mini-css-extract-plugin
export default {"finRow":"UserDetail_finRow__RciPC","finCard":"UserDetail_finCard__0fo51","finLabel":"UserDetail_finLabel__OzZAQ","finValue":"UserDetail_finValue__F-5IN"};